module.exports = __webpack_public_path__ + "static/img/4.084ca80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/4.png
// module id = P8NK
// module chunks = 0